export const currentEnvironment = () =>
  !process.env.REACT_APP_ENVIRONMENT ||
  process.env.REACT_APP_ENVIRONMENT === "development";
